
import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Spinner } from 'react-bootstrap';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SidebarProvider } from '../context/SidebarContext';
import SidebarContainer from '../components/common/SidebarContainer';
import ContentContainer from '../components/common/ContentContainer';
import SoporteView from '../components/common/SoporteView';

import '../styles/global-sidebar.css';

// Lazy loading de componentes
const UTPDashboard = lazy(() => import('../components/utp/UTPDashboard'));
const UTPPlanningView = lazy(() => import('../components/utp/UTPPlanningView'));
const UTPMonitoringView = lazy(() => import('../components/utp/UTPMonitoringView'));
const UTPStaffingView = lazy(() => import('../components/utp/UTPStaffingView'));
const FeedbackModal = lazy(() => import('../components/utp/FeedbackModal'));

// Componente de carga
const LoadingSpinner = () => (
  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Cargando...</span>
    </Spinner>
  </div>
);

const UTPView = () => {
  useEffect(() => { document.title = 'Artemis — Jefe UTP'; }, []);

  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [selectedPlannedClassId, setSelectedPlannedClassId] = useState(null);
  const [selectedTeacherName, setSelectedTeacherName] = useState('');
  const handleRowClick = (data) => {
    setSelectedPlannedClassId(data.id);
    setSelectedTeacherName(data.teacherName || '');
    setShowFeedbackModal(true);
  };

  const handleCloseFeedbackModal = () => {
    setShowFeedbackModal(false);
    setSelectedPlannedClassId(null);
    setSelectedTeacherName('');
  };

  const handleCommentAdded = () => {};

  return (
    <>
    <SidebarProvider>
      <div className="global-layout">
        <SidebarContainer />

        <ContentContainer>

          <div className="global-content-body">
            <Suspense fallback={<LoadingSpinner />}>
              <Routes>
                <Route path="/" element={<Navigate to="/utp/inicio" replace />} />
                <Route path="/inicio" element={<UTPDashboard />} />
                <Route path="/planning" element={
                  <UTPPlanningView onPlannedClassClick={handleRowClick} />
                } />
                <Route path="/monitoring" element={<UTPMonitoringView />} />
                <Route path="/dotacion" element={<UTPStaffingView />} />
                <Route path="/reports" element={<div>Reportes</div>} />
                <Route path="/soporte" element={<SoporteView />} />
              </Routes>
            </Suspense>

            {selectedPlannedClassId && (
              <FeedbackModal
                show={showFeedbackModal}
                handleClose={handleCloseFeedbackModal}
                plannedClassId={selectedPlannedClassId}
                onCommentAdded={handleCommentAdded}
              />
            )}
          </div>
        </ContentContainer>
      </div>
    </SidebarProvider>
    </>
  );
};

export default UTPView;
